import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Roadmap")
], -1)
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Register for allowlist to be eligible for the ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" presale ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, " For registered allowlist supporters only ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-left" }, "Exclusively on Foundation", -1)
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Claim ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" CAMPUS airdrop by connecting the wallet that holds ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" NFT(s) on www.dripversity.com ")
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" As an owner of a ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" NFT and its according twin ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" CAMPUS NFT airdrop you are eligible to be featured in the Blockschmidt and community curated, ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Worlds NFT collection on ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://foundation.app/worlds",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Foundation ", -1)
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" The ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Experience is an interactive 3D exhibition on the ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" CAMPUS and will feature artists from the ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Worlds NFT collection on ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  class: "link",
  href: "https://foundation.app/worlds",
  target: "_blank",
  rel: "noopener noreferrer"
}, " Foundation ", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" . ")

import DripversityIcon from "@/components/icons/DripversityIcon.vue";
import AppButton from "@/components/app/AppButton.vue";
import ImageOnlySection from "@/components/section/ImageOnlySection.vue";
import TextCenteredSection from "@/components/section/TextCenteredSection.vue";
import ProgressContainer from "@/components/progress/ProgressContainer.vue";
import ProgressItem from "@/components/progress/ProgressItem.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeRoadmap',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TextCenteredSection, { id: "roadmap" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createVNode(ProgressContainer, null, {
          default: _withCtx(() => [
            _createVNode(ProgressItem, {
              "is-current": true,
              title: "Community Presale",
              tag: "02/2023"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(DripversityIcon, { class: "text-dripversity" }),
                    _hoisted_4
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(ProgressItem, {
              title: "Presale on Foundation",
              tag: "04/2023"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(ProgressItem, {
              title: "Public sale",
              tag: "05/2023"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(ProgressItem, {
              title: "Reveal of the collection",
              tag: "When sold out"
            }),
            _createVNode(ProgressItem, {
              title: "Claim Airdrop",
              tag: "When sold out"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_9,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_10
                ])
              ]),
              _: 1
            }),
            _createVNode(ProgressItem, {
              title: "DRIPVERISTY Worlds - a curated collection",
              tag: "Q4 2023"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_13,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_14,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_15,
                  _hoisted_16
                ])
              ]),
              _: 1
            }),
            _createVNode(ProgressItem, {
              isLast: true,
              title: "DRIPVERISTY Experience",
              tag: "After DRIPVERISTY Worlds"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_19,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_20,
                  _createVNode(DripversityIcon, { class: "text-dripversity" }),
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})